import { cn } from '@gto/ui/cn'
import { IconButton } from '@gto/ui/icon-button'
import { XMarkIcon } from '@gto/ui/icons/outline'

type CloseButtonProps = {
  onClose: () => void
  /** aria-label for the close button. Defaults to "Close". */
  label?: string
  /** Merged with the default `absolute right-0 top-0` positioning. */
  className?: string
}

/**
 * The canonical dialog close (X) affordance (FE-707). `Dialog.Header` renders it
 * for you — reach for this directly only on a surface that has no header row, e.g.
 * a promo takeover whose title belongs in the centered content column while the X
 * stays pinned to the popup corner.
 */
export const CloseButton = ({ onClose, label = 'Close', className }: CloseButtonProps) => (
  <IconButton
    aria-label={label}
    className={cn('absolute right-0 top-0', className)}
    color="secondary"
    size="medium"
    onClick={onClose}
  >
    <XMarkIcon />
  </IconButton>
)
